import React, { useState, useEffect, useContext } from 'react';
import { UserOrderContext } from 'context/context';
import ModifierCardTemplate from 'molecules/ModifierCard/AU/Presentation/ModifierCardTemplate';
import {
  getAndCheck,
  isEmptyObject,
  toastifyFnWithImage,
  getTernaryValue,
  getValueByKeyName,
  getDispositionTypeOnAPIFormat,
  isEmptyEvery,
  safeUpperCase,
  getFullImagePath,
} from 'common/utilities/utils';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { toast } from 'react-toastify';
import ImageComponent from 'atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import PRODUCT_CUSTOM_CONSTANTS from 'organisms/ProductListingCustomizationComponent/Constants/CustomizationConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import {
  getSelectedFlag,
  setDefaultFlagCheck,
} from 'organisms/ProductListingModalOptions/AU/Presentation/ModifierCard';
import { useLocation } from 'react-router-dom';
import {
  getSavedIsDefault,
  getSavedPrice,
  getSavedQuantity,
  onSaveProductHandler,
  updateItemPrice,
  updateModifier,
  updateModifierNewProps,
  validateFreeInputField,
} from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';

const getObjPath = (isModal, id, modgrpId, sopacPDPCustomization) => {
  const { showCustomizationModId = '', showCustomizationModGrpId = '' } = sopacPDPCustomization;
  if (isModal) {
    return `${showCustomizationModGrpId}${MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL}${showCustomizationModId}${MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL}${modgrpId}${MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL}${id}`;
  } else {
    return `${modgrpId}${MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL}${id}`;
  }
};
export const updatePayloadOnCustomization = (
  isModal,
  pdpPayloadData,
  objpath,
  quantity,
  userOrderStateDispatch,
  PDP_PAYLOAD_DATA,
) => {
  let updatedData;
  if (!isModal) {
    updatedData = updateModifier(pdpPayloadData, objpath, quantity);
  } else {
    updatedData = updateModifierNewProps(pdpPayloadData, objpath, quantity);
  }
  userOrderStateDispatch({ type: PDP_PAYLOAD_DATA, value: updatedData });
};

export const customizeClickHandler = clickHandlerObject => {
  const { event, id, modgrpId, userOrderStateDispatch, SHOW_PDP_CUSTOM_MODAL, modGrpName } = clickHandlerObject;
  event.preventDefault();
  event.stopPropagation();
  userOrderStateDispatch({
    type: SHOW_PDP_CUSTOM_MODAL,
    value: {
      showPDPCustomization: true,
      modifierId: id,
      modgrpId: modgrpId,
      modgrpName: modGrpName,
      updatedPrice: 0,
    },
  });
};
export const getAddToOrderConfirmButtonState = (
  updatedCount,
  modgrpMin,
  SET_PDP_BUTTON_DISABLED,
  userOrderStateDispatch,
  userOrderState,
  modgrpId,
) => {
  let { pdpAddtoCartConfirmButtonDisabled } = userOrderState;
  let checkIfMinExceeded = updatedCount < modgrpMin;
  pdpAddtoCartConfirmButtonDisabled[modgrpId] = checkIfMinExceeded;
  userOrderStateDispatch({ type: SET_PDP_BUTTON_DISABLED, value: pdpAddtoCartConfirmButtonDisabled });
};

const resetItemQuantity = (
  quanitityModifier,
  modgrpMin,
  SET_PDP_BUTTON_DISABLED,
  userOrderStateDispatch,
  userOrderState,
  modgrpId,
  pdpDataForUpdateFoodLine,
) => {
  const { isExcluded, quantity, isModal, qty } = quanitityModifier;
  if (isExcluded) {
    getAddToOrderConfirmButtonState(
      0,
      modgrpMin,
      SET_PDP_BUTTON_DISABLED,
      userOrderStateDispatch,
      userOrderState,
      modgrpId,
    );
    return 0;
  } else if (pdpDataForUpdateFoodLine?.foodLineId && quantity && !isModal) {
    return quantity;
  } else {
    return qty;
  }
};
const ModifierCardComponent = props => {
  const [itemCount, setItemCount] = useState();
  const [isModgrpMax, setModgrpMax] = useState(false);
  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  const { MAX_ALERT_TEXT_INITIAL, MAX_ALERT_TEXT_END } = PRODUCT_CUSTOM_CONSTANTS;
  const {
    PDP_PAYLOAD_DATA,
    UPDATE_SHOW_PDP_CUSTOM_MODAL,
    SET_PDP_BUTTON_DISABLED,
    PEROPTIONMAX_KEY,
    PEROPTIONMIN_KEY,
    SHOW_PDP_CUSTOM_MODAL,
  } = MENU_PDP_PAGE_CONSTANTS;
  const [selectedProduct, setSelectedProduct] = useState();
  const [itemCountToDisplay, setItemCountToDisplay] = useState();
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const {
    tenantData,
    cardData,
    savedCustomizedModifier,
    saveCustomizedItemCount,
    savedModifierHandler,
    savedModifiers,
    updatedItems,
    toRenderCheckBox,
    toRenderQuantityModifier,
    modgrpData,
    isModal,
    isStoreClosed,
    initialRender,
    setInitialRender,
    catalog,
    localized,
  } = props;
  const { modgrpId, max: modgrpMax, min: modgrpMin, modGrpName, additionalProperties } = modgrpData;
  const { id = '', isDefault, defaultQuantity, name, size, isHidden, quantity, isExcluded } = cardData;
  const { pdpPayloadData, sopacPDPCustomization, pdpDataForUpdateFoodLine } = userOrderState;
  const pdpToastShowDuration = tenantData?.componentOptions?.web?.pdp?.pdpToastShowDuration;
  const pdpCateringItemQuantityLimit = tenantData?.componentOptions?.web?.pdp?.pdpCateringItemQuantityLimit;
  const itemCountShouldAtModifierLevel = tenantData?.componentOptions?.web?.pdp?.itemCountShouldAtModifierLevel;
  const location = useLocation();
  const objPath = getObjPath(isModal, id, modgrpId, sopacPDPCustomization);
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW))
    : userOrderState.dispositionNew;
  const dispositionType = dispositionNew?.type && safeUpperCase(getDispositionTypeOnAPIFormat(dispositionNew?.type));
  const getModgrpCount = () => {
    return isEmptyObject(savedCustomizedModifier) ? savedCustomizedModifier.totalQuantity : 0;
  };
  useEffect(() => {
    if (itemCount !== undefined) {
      //create path to fetch and update data
      let prevQty = getSavedQuantity(pdpPayloadData, objPath);
      if (getAndCheck(prevQty !== itemCount, prevQty !== null)) {
        updatePayloadOnCustomization(
          isModal,
          pdpPayloadData,
          objPath,
          itemCount,
          userOrderStateDispatch,
          PDP_PAYLOAD_DATA,
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemCount]);

  useEffect(() => {
    if (selectedProduct !== undefined) {
      let prevFlag = getSavedIsDefault(pdpPayloadData, objPath);
      if (getAndCheck(prevFlag !== selectedProduct, prevFlag !== null)) {
        let quantityInfo = selectedProduct ? 1 : 0;
        updatePayloadOnCustomization(
          isModal,
          pdpPayloadData,
          objPath,
          quantityInfo,
          userOrderStateDispatch,
          PDP_PAYLOAD_DATA,
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProduct]);

  useEffect(() => {
    if (toRenderQuantityModifier) {
      let savedItem = savedCustomizedModifier?.[modgrpId]?.[id];
      if (savedItem) {
        setItemCount(savedItem.quantity);
        setItemCountToDisplay(savedItem.quantityDisplay);
        savedItem?.quantity > 0 ? setSelectedProduct(true) : setSelectedProduct(false);
      } else {
        let defaultQty = getTernaryValue(isDefault, defaultQuantity, 0);
        let qty = getTernaryValue(initialRender && !isModal, defaultQty, getSavedQuantity(pdpPayloadData, objPath));
        let quanitityModifier = { isExcluded, qty, isModal, quantity };
        qty = resetItemQuantity(
          quanitityModifier,
          modgrpMin,
          SET_PDP_BUTTON_DISABLED,
          userOrderStateDispatch,
          userOrderState,
          modgrpId,
          pdpDataForUpdateFoodLine,
        );
        saveCustomizedItemCount(id, modgrpId, '', qty);
      }
      if (isEmptyObject(savedCustomizedModifier)) {
        let modgrpCount = getModgrpCount();
        if (modgrpCount === modgrpMax) {
          setModgrpMax(true);
        } else {
          setModgrpMax(false);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, savedCustomizedModifier]);

  const handleCateringModifierQuantity = event => {
    event.preventDefault();
    let modgrpCount = getModgrpCount();
    let modifierMax = +getValueByKeyName(additionalProperties, PEROPTIONMAX_KEY);
    let modifierMin = +getValueByKeyName(additionalProperties, PEROPTIONMIN_KEY);
    let validationFields = {
      modgrpMax,
      modgrpMin,
      modifierMax,
      modifierMin,
      modgrpCount,
      itemCount,
      SET_PDP_BUTTON_DISABLED,
      userOrderStateDispatch,
      userOrderState,
      modgrpId,
      pdpCateringItemQuantityLimit,
    };
    let resultQuantity = validateFreeInputField(event, validationFields);
    let quantityInfo = resultQuantity.valueToCount;
    let quantityToDisplay = resultQuantity.valueToDisplay;
    if (quantityInfo !== false) {
      saveCustomizedItemCount(id, modgrpId, null, quantityInfo, quantityToDisplay);
      //getSavedPrice for single item
      let modifierPrice = getSavedPrice(pdpPayloadData, objPath, 1);
      //calculate total updated price for modifier
      let priceToAdd = modifierPrice * quantityInfo - modifierPrice * itemCount;
      //in updateItemPrice reduce the singleitemprice*prevqty and add singleitemprice*currentqty
      let getPayloadUpdated = updateItemPrice(
        pdpPayloadData,
        { price: priceToAdd, flag: QUANTITY_ACTION.Increase },
        isModal,
      );
      userOrderStateDispatch({ type: PDP_PAYLOAD_DATA, value: getPayloadUpdated });
      let modGupdatedPrice = sopacPDPCustomization.updatedPrice + priceToAdd;
      userOrderStateDispatch({ type: UPDATE_SHOW_PDP_CUSTOM_MODAL, value: { updatedPrice: modGupdatedPrice } });
    }
  };

  const updateItemQuantity = (item, flag, event) => {
    let modgrpCount = getModgrpCount();
    if (flag === QUANTITY_ACTION.Decrease || modgrpMax > modgrpCount) {
      let updatedModgrpCount = getTernaryValue(flag === QUANTITY_ACTION.Decrease, modgrpCount - 1, modgrpCount + 1);
      getAddToOrderConfirmButtonState(
        updatedModgrpCount,
        modgrpMin,
        SET_PDP_BUTTON_DISABLED,
        userOrderStateDispatch,
        userOrderState,
        modgrpId,
      );
      saveCustomizedItemCount(id, modgrpId, flag);
      let modifierPrice = getSavedPrice(pdpPayloadData, objPath, 1);
      let getPayloadUpdated = updateItemPrice(pdpPayloadData, { price: modifierPrice, flag }, isModal);
      userOrderStateDispatch({ type: PDP_PAYLOAD_DATA, value: getPayloadUpdated });
      let updatedPrice =
        flag === QUANTITY_ACTION.Decrease
          ? sopacPDPCustomization.updatedPrice - modifierPrice
          : sopacPDPCustomization.updatedPrice + modifierPrice;
      userOrderStateDispatch({ type: UPDATE_SHOW_PDP_CUSTOM_MODAL, value: { updatedPrice } });
    } else {
      let imageTemplate = <ImageComponent srcFile={IMAGE_PATH.ErrorImage} />;
      let message = `${translateWithI18Next(MAX_ALERT_TEXT_INITIAL)}${modgrpMax} ${translateWithI18Next(
        MAX_ALERT_TEXT_END,
      )}`;
      toastifyFnWithImage(message, imageTemplate, 'err-toast', true);
      pdpToastShowDuration &&
        setTimeout(() => {
          toast.dismiss();
        }, pdpToastShowDuration);
    }
  };

  useEffect(() => {
    if (toRenderCheckBox) {
      let defaultFlag = getTernaryValue(
        savedModifiers.length > 0,
        getSavedIsDefault(pdpPayloadData, objPath),
        isDefault,
      );
      let flag = getTernaryValue(isModal, getSavedIsDefault(pdpPayloadData, objPath), defaultFlag);
      let setSelectedFlag = setDefaultFlagCheck(updatedItems, userOrderState, id, flag, undefined, initialRender);
      getSelectedFlag(setSelectedFlag, setSelectedProduct, savedModifierHandler, cardData, savedModifiers);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, updatedItems, isDefault, savedModifiers, savedModifierHandler, selectedProduct]);

  const onSaveProduct = () => {
    let saveProductParams = {
      modgrpMax,
      selectedProduct,
      modgrpMin,
      name,
      size,
      location,
      setInitialRender,
      savedModifierHandler,
      setSelectedProduct,
      cardData,
      savedModifiers,
      userOrderState,
      userOrderStateDispatch,
      modGrpName,
      pdpPayloadData,
      objPath,
      isModal,
    };
    onSaveProductHandler(saveProductParams);
  };
  return (
    <ModifierCardTemplate
      {...props}
      isHidden={isHidden}
      selectedProduct={selectedProduct}
      updateItemQuantity={updateItemQuantity}
      itemCount={itemCountToDisplay}
      isModgrpMax={isModgrpMax}
      onSaveProduct={onSaveProduct}
      isStoreClosed={isStoreClosed}
      handleCateringModifierQuantity={handleCateringModifierQuantity}
      dispositionType={dispositionType}
      kilojoule={tenantData.kilojoule}
      defaultImagePath={getFullImagePath(null, tenantData, true)}
      itemCountShouldAtModifierLevel={itemCountShouldAtModifierLevel}
      customizeClickHandler={event =>
        customizeClickHandler({ event, id, modgrpId, userOrderStateDispatch, SHOW_PDP_CUSTOM_MODAL, modGrpName })
      }
      localized={localized}
      showButton={cardData?.modgrps?.length > 0 && localized && !isStoreClosed && !isModal}
      catalog={catalog}
      savedCustomizedModifier={savedCustomizedModifier}
    />
  );
};

export default ModifierCardComponent;
